var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"rich-text-editor",style:({ border: '1px solid #ddd' })})
}
var staticRenderFns = []

export { render, staticRenderFns }